export const concatBasePathWithPath = (path: string, basePath: string): string => {
  const base = basePath.endsWith('/') ? basePath : `${basePath}/`;
  return `${base}${path}`;
};
